/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   search\client\webapi\clientgeneratorconfigs\genclient.json
 */

"use strict";

import Contracts = require("Search.Client/Contracts");
import Search_Shared_Contracts = require("Search.Client/Shared/Search.Shared.Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods2To7_2 extends VSS_WebApi.VssHttpClient {

    public static serviceInstanceId = "00000010-0000-8888-8000-000000000000";
    protected advancedCodeSearchResultsApiVersion: string;
    protected codeSearchPaginatedResultsApiVersion: string;
    protected codeSearchResultsApiVersion: string;
    protected packageSearchResultsApiVersion: string;
    protected wikiSearchResultsApiVersion: string;
    protected workItemSearchResultsApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * Provides a set of results for the search text.
     *
     * @param {Contracts.WorkItemSearchRequest} request - The Work Item Search Request.
     * @param {string} project - Project ID or project name
     * @return IPromise<Contracts.WorkItemSearchResponse>
     */
    public fetchWorkItemSearchResults(
        request: Contracts.WorkItemSearchRequest,
        project?: string
        ): IPromise<Contracts.WorkItemSearchResponse> {

        return this._beginRequest<Contracts.WorkItemSearchResponse>({
            httpMethod: "POST",
            area: "search",
            locationId: "73b2c9e2-ff9e-4447-8cda-5f5b21ff7cae",
            resource: "workItemSearchResults",
            routeTemplate: "{project}/_apis/{area}/{resource}",
            routeValues: {
                project: project
            },
            apiVersion: this.workItemSearchResultsApiVersion,
            data: request
        });
    }

    /**
     * Provides a set of results for the search request.
     *
     * @param {Search_Shared_Contracts.WikiSearchRequest} request - The Wiki Search Request.
     * @param {string} project - Project ID or project name
     * @return IPromise<Search_Shared_Contracts.WikiSearchResponse>
     */
    public fetchWikiSearchResults(
        request: Search_Shared_Contracts.WikiSearchRequest,
        project?: string
        ): IPromise<Search_Shared_Contracts.WikiSearchResponse> {

        return this._beginRequest<Search_Shared_Contracts.WikiSearchResponse>({
            httpMethod: "POST",
            area: "search",
            locationId: "e90e7664-7049-4100-9a86-66b161d81080",
            resource: "wikiSearchResults",
            routeTemplate: "{project}/_apis/{area}/{resource}",
            routeValues: {
                project: project
            },
            apiVersion: this.wikiSearchResultsApiVersion,
            data: request
        });
    }

    /**
     * Provides a set of results for the search text.
     *
     * @param {Search_Shared_Contracts.PackageSearchRequest} request - The Package Search Request.
     * @return IPromise<Search_Shared_Contracts.PackageSearchResponse>
     */
    public fetchPackageSearchResults(
        request: Search_Shared_Contracts.PackageSearchRequest
        ): IPromise<Search_Shared_Contracts.PackageSearchResponse> {

        return this._beginRequest<[any, string, JQueryXHR]>({
            httpMethod: "POST",
            area: "search",
            locationId: "f62ada48-eedc-4c8e-93f0-de870e4ecce0",
            resource: "packageSearchResults",
            routeTemplate: "_apis/{area}/{resource}",
            apiVersion: this.packageSearchResultsApiVersion,
            data: request
        }, true).then(([data, textStatus, jqXHR]) => {
            const activityIdHeader = jqXHR.getResponseHeader("ActivityId");
            return {
                content: data,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
        });
    }

    /**
     * Provides a set of results for the search text.
     *
     * @param {Contracts.CodeSearchRequest} request - The Code Search Request.
     * @param {string} project - Project ID or project name
     * @return IPromise<Contracts.CodeSearchResponse>
     */
    public fetchCodeSearchResults(
        request: Contracts.CodeSearchRequest,
        project?: string
        ): IPromise<Contracts.CodeSearchResponse> {

        return this._beginRequest<Contracts.CodeSearchResponse>({
            httpMethod: "POST",
            area: "search",
            locationId: "e7f29993-5b82-4fca-9386-f5cfe683d524",
            resource: "codeSearchResults",
            routeTemplate: "{project}/_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.CodeSearchResponse,
            routeValues: {
                project: project
            },
            apiVersion: this.codeSearchResultsApiVersion,
            data: request
        });
    }

    /**
     * Provides a set of results for the search text.
     *
     * @param {Search_Shared_Contracts.ScrollSearchRequest} request - The Code Search Request.
     * @param {string} project - Project ID or project name
     * @return IPromise<Contracts.CodeSearchResponse>
     */
    public fetchScrollCodeSearchResults(
        request: Search_Shared_Contracts.ScrollSearchRequest,
        project?: string
        ): IPromise<Contracts.CodeSearchResponse> {

        return this._beginRequest<Contracts.CodeSearchResponse>({
            httpMethod: "POST",
            area: "search",
            locationId: "852dac94-e8f7-45a2-9910-927ae35766a2",
            resource: "codeSearchPaginatedResults",
            routeTemplate: "{project}/_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.CodeSearchResponse,
            routeValues: {
                project: project
            },
            apiVersion: this.codeSearchPaginatedResultsApiVersion,
            data: request
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Provides a set of results for the search text.
     *
     * @param {Contracts.CodeSearchRequest} request - The Code Search Request.
     * @param {string} project - Project ID or project name
     * @return IPromise<Contracts.CodeSearchResponse>
     */
    public fetchAdvancedCodeSearchResults(
        request: Contracts.CodeSearchRequest,
        project?: string
        ): IPromise<Contracts.CodeSearchResponse> {

        return this._beginRequest<Contracts.CodeSearchResponse>({
            httpMethod: "POST",
            area: "search",
            locationId: "6bc8d206-9a7e-4cfb-83e1-c9a81e7bf166",
            resource: "advancedCodeSearchResults",
            routeTemplate: "{project}/_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.CodeSearchResponse,
            routeValues: {
                project: project
            },
            apiVersion: this.advancedCodeSearchResultsApiVersion,
            data: request
        });
    }
}

export class CommonMethods5To7_2 extends CommonMethods2To7_2 {
    protected customRepositoriesApiVersion: string;
    protected customRepositoryBranchApiVersion: string;
    protected repositoriesApiVersion: string;
    protected tfvcApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * Provides status of TFVC Repository.
     *
     * @param {string} project - Project ID or project name
     * @return IPromise<Contracts.TfvcRepositoryStatusResponse>
     */
    public getTfvcRepositoryStatus(
        project: string
        ): IPromise<Contracts.TfvcRepositoryStatusResponse> {

        return this._beginRequest<Contracts.TfvcRepositoryStatusResponse>({
            httpMethod: "GET",
            area: "search",
            locationId: "d5bf4e52-e0af-4626-8c50-8a80b18fa69f",
            resource: "tfvc",
            routeTemplate: "{project}/_apis/{area}/status/{resource}",
            responseType: Contracts.TypeInfo.TfvcRepositoryStatusResponse,
            routeValues: {
                project: project
            },
            apiVersion: this.tfvcApiVersion
        });
    }

    /**
     * Provides status of Repository.
     *
     * @param {string} project - Project ID or project name
     * @param {string} repository - Repository ID or repository name.
     * @return IPromise<Contracts.RepositoryStatusResponse>
     */
    public getRepositoryStatus(
        project: string,
        repository: string
        ): IPromise<Contracts.RepositoryStatusResponse> {

        return this._beginRequest<Contracts.RepositoryStatusResponse>({
            httpMethod: "GET",
            area: "search",
            locationId: "1f60303c-7261-4387-80f1-742a2ecf2964",
            resource: "repositories",
            routeTemplate: "{project}/_apis/{area}/status/{resource}/{repository}",
            responseType: Contracts.TypeInfo.RepositoryStatusResponse,
            routeValues: {
                project: project,
                repository: repository
            },
            apiVersion: this.repositoriesApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Provides indexing status of custom repository branch
     *
     * @param {string} project - Project ID or project name
     * @param {string} repository
     * @param {string} branch
     * @return IPromise<Contracts.CustomRepositoryBranchStatusResponse>
     */
    public getCustomRepositoryBranchStatus(
        project: string,
        repository: string,
        branch: string
        ): IPromise<Contracts.CustomRepositoryBranchStatusResponse> {

        return this._beginRequest<Contracts.CustomRepositoryBranchStatusResponse>({
            httpMethod: "GET",
            area: "search",
            locationId: "5d9391b9-e2c3-4b87-9033-83c3aed4069e",
            resource: "customRepositoryBranch",
            routeTemplate: "{project}/_apis/{area}/{resource}/{repository}/{branch}",
            responseType: Contracts.TypeInfo.CustomRepositoryBranchStatusResponse,
            routeValues: {
                project: project,
                repository: repository,
                branch: branch
            },
            apiVersion: this.customRepositoryBranchApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Provides status of Custom Repository.
     *
     * @param {string} project - Project ID or project name
     * @param {string} repository - Repository ID or repository name for a custom repository.
     * @return IPromise<Contracts.CustomRepositoryStatusResponse>
     */
    public getCustomRepositoryStatus(
        project: string,
        repository: string
        ): IPromise<Contracts.CustomRepositoryStatusResponse> {

        return this._beginRequest<Contracts.CustomRepositoryStatusResponse>({
            httpMethod: "GET",
            area: "search",
            locationId: "de4c37b8-f55f-4c38-8f3f-a296cfb63121",
            resource: "customRepositories",
            routeTemplate: "{project}/_apis/{area}/status/{resource}/{repository}",
            responseType: Contracts.TypeInfo.CustomRepositoryStatusResponse,
            routeValues: {
                project: project,
                repository: repository
            },
            apiVersion: this.customRepositoriesApiVersion
        });
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient7_2 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.advancedCodeSearchResultsApiVersion =
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "7.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient7_1 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "7.1";
        this.advancedCodeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion = "7.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient7 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "7.0";
        this.advancedCodeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion = "7.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient6_1 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "6.1";
        this.advancedCodeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion = "6.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient6 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "6.0";
        this.advancedCodeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion = "6.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient5_2 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "5.2";
        this.advancedCodeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion = "5.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient5_1 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "5.1";
        this.advancedCodeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion = "5.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient5 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.repositoriesApiVersion =
        this.tfvcApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "5.0";
        this.advancedCodeSearchResultsApiVersion =
        this.customRepositoriesApiVersion =
        this.customRepositoryBranchApiVersion = "5.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient4_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "4.1";
        this.advancedCodeSearchResultsApiVersion = "4.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient4 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "4.0";
        this.advancedCodeSearchResultsApiVersion = "4.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient3_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "3.2";
        this.advancedCodeSearchResultsApiVersion = "3.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient3_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "3.1";
        this.advancedCodeSearchResultsApiVersion = "3.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "3.0";
        this.advancedCodeSearchResultsApiVersion = "3.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient2_3 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "2.3";
        this.advancedCodeSearchResultsApiVersion = "2.3-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient2_2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "2.2";
        this.advancedCodeSearchResultsApiVersion = "2.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient2_1 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "2.1";
        this.advancedCodeSearchResultsApiVersion = "2.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class SearchHttpClient2 extends CommonMethods2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.codeSearchPaginatedResultsApiVersion =
        this.codeSearchResultsApiVersion =
        this.packageSearchResultsApiVersion =
        this.wikiSearchResultsApiVersion =
        this.workItemSearchResultsApiVersion = "2.0";
        this.advancedCodeSearchResultsApiVersion = "2.0-preview.1";
    }
}

export class SearchHttpClient extends SearchHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": SearchHttpClient7_2,
    "7.1": SearchHttpClient7_1,
    "7.0": SearchHttpClient7,
    "6.1": SearchHttpClient6_1,
    "6.0": SearchHttpClient6,
    "5.2": SearchHttpClient5_2,
    "5.1": SearchHttpClient5_1,
    "5.0": SearchHttpClient5,
    "4.1": SearchHttpClient4_1,
    "4.0": SearchHttpClient4,
    "3.2": SearchHttpClient3_2,
    "3.1": SearchHttpClient3_1,
    "3.0": SearchHttpClient3,
    "2.3": SearchHttpClient2_3,
    "2.2": SearchHttpClient2_2,
    "2.1": SearchHttpClient2_1,
    "2.0": SearchHttpClient2
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return SearchHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): SearchHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<SearchHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<SearchHttpClient7_1>(SearchHttpClient7_1, undefined, undefined, undefined, options);
    }
}
